module.exports = __webpack_public_path__ + "static/media/3_of_clubs.3f402411.png";